import { Grid } from '@mui/material';



const AuthLayout = ({ children }) => {
  return (
    <Grid 
      container 
      height='100vh'
      width='100%'
    >
      <Grid item width='100%' >
        {children}
      </Grid>
    </Grid>
  )
};

export default AuthLayout;
